import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { SiteNav } from './components/SiteNav';
import { SiteFooter } from './components/SiteFooter';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Impact } from './pages/Impact';
import { Expertise } from './pages/Expertise';
import { Experience } from './pages/Experience';
import { CorporateDevelopment } from './pages/CorporateDevelopment';
import { Skills } from './pages/Skills';
import { Education } from './pages/Education';
import { Philosophy } from './pages/Philosophy';
import { Contact } from './pages/Contact';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="28sl5f2ubjwhm">
      <ScrollToTop data-id="element-1" data-mp="28s30zixi6bym" />
      <div className="flex min-h-full w-full flex-col bg-paper font-sans antialiased" data-id="element-2" data-mp="23vuo6c6s2uum">
        <SiteNav data-id="element-3" data-mp="3ijxsv0nzqion" />
        <main className="flex-1" data-id="element-4" data-mp="3ikh5q2ysagvt">
          <Routes data-id="element-5" data-mp="3ijfvg0pldyf5">
            <Route path="/" element={<Home data-id="element-7" data-mp="3mlawr57iwbsx" />} data-id="element-6" data-mp="3ihv0wb3a2fha" />
            <Route path="/about" element={<About data-id="element-9" data-mp="3mjztr7lwj82v" />} data-id="element-8" data-mp="3mkrchhuehbbq" />
            <Route path="/impact" element={<Impact data-id="element-11" data-mp="3rbrakqf99zft" />} data-id="element-10" data-mp="3mj6hjr46bqdc" />
            <Route path="/expertise" element={<Expertise data-id="element-13" data-mp="3recd7hndojem" />} data-id="element-12" data-mp="3rdki07xp0nov" />
            <Route path="/experience" element={<Experience data-id="element-15" data-mp="4wylxj0jajy" />} data-id="element-14" data-mp="5or2zhbcs60" />
            <Route path="/corporate-development" element={<CorporateDevelopment data-id="element-17" data-mp="2zllcouynw8jk" />} data-id="element-16" data-mp="82lr78302d1" />
            <Route path="/skills" element={<Skills data-id="element-19" data-mp="2znfyebhrc4op" />} data-id="element-18" data-mp="2zmo5x9jgin2n" />
            <Route path="/education" element={<Education data-id="element-21" data-mp="33ngiabnml835" />} data-id="element-20" data-mp="33m5ck6amdq9e" />
            <Route path="/philosophy" element={<Philosophy data-id="element-23" data-mp="38l8gfnev5qfs" />} data-id="element-22" data-mp="33orkw85c49so" />
            <Route path="/contact" element={<Contact data-id="element-25" data-mp="38nupxslbeg0n" />} data-id="element-24" data-mp="38l05i12awv78" />
            <Route path="*" element={<Home data-id="element-27" data-mp="3dlw727z6k59h" />} data-id="element-26" data-mp="3dkl5met7j9lj" />
          </Routes>
        </main>
        <SiteFooter data-id="element-28" data-mp="3dii694660445" />
      </div>
    </BrowserRouter>;
}